module.exports = __webpack_public_path__ + "img/1525937962.0052a476.jpg";